import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=660c5a06&scoped=true"
import script from "./CompleteRegistration.vue?vue&type=script&lang=ts"
export * from "./CompleteRegistration.vue?vue&type=script&lang=ts"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=660c5a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c5a06",
  null
  
)

export default component.exports